<div fxLayout="column" style="max-width: 1176px;">
  <ngx-dynamic-hooks [content]="content"></ngx-dynamic-hooks>
</div>
